import { useEffect, useState } from 'react';
import { Card, Empty, ErrorBanner } from '../components/Layout.jsx';
import { apiFetch } from '../store.js';

// The worker doesn't ship a /dashboard/contacts list endpoint in v1 — instead
// the operator types a contact's local primary key and we fetch the detail.
// The list view is intentionally light; full search lives in the desktop app.

export default function Contacts() {
  const [contactId, setContactId] = useState('');
  const [detail, setDetail] = useState(null);
  const [error, setError] = useState(null);
  const [busy, setBusy] = useState(false);

  async function load(e) {
    e?.preventDefault();
    if (!contactId.trim()) return;
    setError(null);
    setBusy(true);
    try {
      const d = await apiFetch(`/dashboard/contacts/${encodeURIComponent(contactId.trim())}`);
      setDetail(d);
    } catch (err) {
      setDetail(null);
      setError(err);
    } finally {
      setBusy(false);
    }
  }

  return (
    <>
      <ErrorBanner error={error} />

      <Card title="Look up contact">
        <form onSubmit={load} style={{ display: 'flex', gap: 'var(--space-sm)' }}>
          <input
            placeholder="Contact id (local primary key)"
            value={contactId}
            onChange={(e) => setContactId(e.target.value)}
            style={{ flex: 1 }}
          />
          <button className="btn" type="submit" disabled={busy || !contactId.trim()}>
            {busy ? 'Loading…' : 'Fetch'}
          </button>
        </form>
      </Card>

      {detail && (
        <>
          <Card title="Contact">
            <dl style={{ display: 'grid', gridTemplateColumns: '180px 1fr', rowGap: 8, margin: 0 }}>
              <dt>Name</dt><dd>{detail.contact?.name || '—'}</dd>
              <dt>Platform</dt><dd>{detail.contact?.platform || '—'}</dd>
              <dt>Handle</dt><dd>{detail.contact?.handle || '—'}</dd>
              <dt>Stage</dt><dd>{detail.contact?.stage || '—'}</dd>
              <dt>Preferred tone</dt><dd>{detail.contact?.preferred_tone || '—'}</dd>
              <dt>Notes</dt><dd>{detail.contact?.notes || '—'}</dd>
              <dt>Updated at</dt><dd>{detail.contact?.updated_at || '—'}</dd>
            </dl>
          </Card>

          <Card title="Recent analyses">
            {(detail.recent_analyses || []).length === 0 ? (
              <Empty>No analyses for this contact yet.</Empty>
            ) : (
              <table>
                <thead>
                  <tr>
                    <th>ID</th><th>Brand</th><th>Engine</th>
                    <th>Tone</th><th>Latency</th><th>Created</th>
                  </tr>
                </thead>
                <tbody>
                  {detail.recent_analyses.map((a) => (
                    <tr key={a.id}>
                      <td><code>{a.id}</code></td>
                      <td>{a.brand_key || '—'}</td>
                      <td>{a.engine_name || '—'}</td>
                      <td>{a.tone || '—'}</td>
                      <td>{a.latency_ms ?? '—'}ms</td>
                      <td>{a.created_at || '—'}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            )}
          </Card>
        </>
      )}
    </>
  );
}
